export const pdfMap: Record<string, string> = {
	consent_ibercaja: 'consent-ibercaja.pdf',
	consent_caixabank: 'consent-caixa.pdf',
	consent_sabadell: 'consent-sabadell.pdf',
	consent_sabadell_saas: 'consent-sabadell-saas.pdf',
	consent_targobank: 'consent-targobank.pdf',
	consent_caja_rural_sur: 'consent-caja-rural-sur.pdf',
	consent_sabadell_extra: 'consent-sabadell-extra.pdf',
	consent_abanca: 'consent-abanca-saas.pdf',
	consent_bankinter: 'consent-bankinter.pdf',
	consent_engel: 'consent-engel-1.pdf',
	consent_sc_es: 'consent-safecredit.pdf',
	consent_globalcaja: 'consent-globalcaja.pdf',
	consent_bbva: 'consent-bbva.pdf',
	consent_kutxabank: 'consent-kutxabank.pdf'
};
